<template>
  <div class="tile info-block">
    <h3 class="content__heading">Request Information:</h3>
    <p class="text__bold text__center subheading">{{ getActive.name }}</p>
    <div class="info-block--grid">
      <div>
        <p class="text__bold text__center">Address</p>
        <p class="flex__between tile--row">
          <span class="text__bold">Street Address:</span>
          <span>{{ getActive.mailAddress }}</span>
        </p>
        <p class="flex__between tile--row">
          <span class="text__bold">City, State Zip:</span>
          <span>{{ getActive.city}}, {{ getActive.state}} {{ getActive.zip }}</span>
        </p>
      </div>
      <div>
        <p class="text__bold text__center">Contact</p>
        <p class="flex__between tile--row">
          <span class="text__bold">Email:</span>
          <span>{{ getActive.email }}</span>
        </p>
        <p class="flex__between tile--row">
          <span class="text__bold">Phone:</span>
          <span>{{ getActive.phone }}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters("optOut", ["getActive"])
  }
};
</script>

<style scoped lang="scss">
</style>